import axios from 'axios';
import { Commit, ActionTree } from 'vuex';
import { RootState } from '@/store/types'
import { AuthState } from '@/store/auth/types'
import { Tutor } from '@/store/tutors/types'
import { convertTutorFromApi } from '@/store/tutors/actions'

const actions: ActionTree<AuthState, RootState> = {
  login: async (
    { commit, getters },
    payload: { loginId: string, password: string },
  ) => {
    const res = await axios.post('/login', payload)
    const profile: Tutor = {
      ...convertTutorFromApi(res.data.profile, getters),
      id: res.data?.profile?.id,
    }

    commit('authenticated',
      { accessToken: res.data.accessToken, profile: profile || null })
    return true
  },
  async logout({ commit }: { commit: Commit }) {
    commit('clearedAuthentication')
    return true
  },
};

export default actions;
